export default __webpack_public_path__ + "static/media/schoolDelete.5a3a3b97.svg";